import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from '@/components/HelloWorld.vue';
import Welcome from '@/components/Welcome.vue';
// import NewHome from '@/components/NewHome.vue';
import LoginPage from '@/components/LoginPage.vue';
import CardDetail from '@/components/CardDetail.vue';
import StreamResponse from '@/components/StreamResponse.vue';

const routes = [
  {
    path: '/',
    redirect: '/login', // 默认重定向到登录页
    meta: { title: '四为师资库-登录页' }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { title: '四为师资库-登录页' }
  },
  {
    path: '/welcome',
    name: '欢迎页面',
    component: Welcome,
    meta: { title: '四为师资库-欢迎页面' }
  },
  {
    path: '/home',
    name: 'Home',
    component: HelloWorld,
    meta: { title: '四为师资库-搜索页' }
  },
  // {
  //   path: '/newhome',
  //   name: '基于大模型搜索',
  //   component: NewHome,
  //   meta: { title: '四为师资库-基于大模型搜索' }
  // },
  {
    path: '/StreamResponse',
    name: '流式输出搜索',
    component: StreamResponse,
    meta: { title: '四为师资库-流式输出搜索' }
  },
  {
    path: '/card/:t_id', // 动态路由，根据卡片ID跳转
    name: 'CardDetail',
    component: CardDetail,
    props: true, // 将路由参数作为props传递
    meta: { title: '四为师资库-详情页' }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;